import '@fontsource-variable/inter-tight';
import {asyncWithLDProvider} from 'launchdarkly-react-client-sdk';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router';
import App from './components/app.jsx';
import {LD_CLIENTSIDE_ID} from './config.js';
import initSentry from './sentry.js';

// Setup Sentry
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LD_CLIENTSIDE_ID,
  });

  root.render(
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <LDProvider>
        <App />
      </LDProvider>
    </BrowserRouter>,
  );
})();
